import {
  AlreadyPrrocessIcon,
  CanceledIcon,
  Column,
  ConsolidateUnprocessedIcon,
  DateCellComponent,
  DoDisturbAltIcon,
  FlexContainer,
  NotFoundIcon,
  PackageCheckIcon,
  ScalesIcon,
  TriangleAlertIcon,
} from '@uni-space/uni-components';
import { useMemo } from 'react';
import { ErrorRow, StatusAcceptanceEnum, SuccessRow } from './consolidator';
import { useTranslation } from 'react-i18next';

export function useConsolidatorTableSettings() {
  const { t } = useTranslation();

  const handleStatus = (status: StatusAcceptanceEnum) => {
    switch (status) {
      case StatusAcceptanceEnum.Already:
        return {
          label: t('alreadyScanned'),
          component: <AlreadyPrrocessIcon color={'#f57c00'} size="s" />,
        };
      case StatusAcceptanceEnum.AlreadyAnotherWarehouse:
        return {
          label: t('alreadyAnotherWarehouse'),
          component: <DoDisturbAltIcon color={'#f57c00'} size="s" />,
        };
      case StatusAcceptanceEnum.Canceled:
        return {
          label: t('canceled'),
          component: <CanceledIcon color="#EF6D7C" size="s" />,
        };
      case StatusAcceptanceEnum.ServiceRestriction:
        return {
          label: t('serviceRestriction'),
          component: <ConsolidateUnprocessedIcon color="#EF6D7C" size="s" />,
        };
      case StatusAcceptanceEnum.NotFound:
        return {
          label: t('parcelNotFound'),
          component: <NotFoundIcon color="#EF6D7C" size="s" />,
        };
      case StatusAcceptanceEnum.UserNotFound:
        return {
          label: t('userNotFound'),
          component: <NotFoundIcon color="#EF6D7C" size="s" />,
        };
      case StatusAcceptanceEnum.QualityControl:
        return {
          label: t('qualityControl'),
          component: <PackageCheckIcon color="#EF6D7C" size="s" />,
        };
      case StatusAcceptanceEnum.HighDensity:
        return {
          label: t('highDensity'),
          component: <ScalesIcon color="#EF6D7C" size="s" />,
        };
      case StatusAcceptanceEnum.InvalidDimensions:
        return {
          label: t('invalidDimensions'),
          component: <TriangleAlertIcon color="#EF6D7C" size="s" />,
        };
      default:
        return {
          label: t('parcelNotFound'),
          component: <NotFoundIcon color="#EF6D7C" size="s" />,
        };
    }
  };

  const errorColumns: Column<ErrorRow>[] = useMemo(
    () => [
      {
        header: t('tableHeader.trackNumber'),
        accessor: 'trackNumber',
        renderCell: (row) => <span className="ct6-code ct6-code--danger">{row.trackNumber}</span>,
        flex: 1,
        minWidth: '140px',
        textAlign: 'center',
      },
      {
        header: t('tableHeader.status'),
        accessor: 'status',
        renderCell: (row: ErrorRow) => (
          <FlexContainer align="center" justify="center" gap="8px">
            {handleStatus(row.status).component}
            <div>{handleStatus(row.status).label}</div>
          </FlexContainer>
        ),
        flex: 1,
        textAlign: 'center',
        minWidth: '140px',
      },
    ],
    [t],
  );

  const successColumns: Column<SuccessRow>[] = useMemo(
    () => [
      {
        header: t('tableHeader.trackNumber'),
        accessor: 'trackNumber',
        renderCell: (row) => <span className="ct6-code">{row.trackNumber}</span>,
        flex: 2,
        textAlign: 'center',
        minWidth: '160px',
      },
      { header: t('tableHeader.regionZone'), textAlign: 'center', accessor: 'regionZone', flex: 1, minWidth: '120px' },
      { header: t('bagCode'), textAlign: 'center', accessor: 'bagCode', flex: 1, minWidth: '120px' },
      { header: t('sortingCode'), textAlign: 'center', accessor: 'sortingCode', flex: 1, minWidth: '120px' },
      {
        header: t('tableHeader.weight'),
        accessor: 'weight',
        renderCell: (row) => (row.weight == null ? '—' : row.weight),
        textAlign: 'center',
        flex: 1,
      },
      {
        header: t('tableHeader.scanAt'),
        accessor: 'scanAt',
        textAlign: 'center',
        renderCell: (row) => <DateCellComponent justify="center" date={row.scanAt} zone='local'  />,
        flex: 1,
        minWidth: '200px',
      },
    ],
    [t],
  );

  return { successColumns, errorColumns };
}
